import {Action} from "@ngrx/store";

export const LOAD_VIBE_LIMITATIONS: string = '[vibe-limitations] Load Vibe Limitations';
export const LOAD_VIBE_LIMITATIONS_SUCCESS: string = '[vibe-limitations] Load Vibe Limitations Success';
export const LOAD_VIBE_LIMITATIONS_FAIL: string = '[vibe-limitations] Load Vibe Limitations Fail';

export class LoadVibeLimitations implements Action {
  readonly type: string = LOAD_VIBE_LIMITATIONS;
  constructor(public payload?: number) {}
}

export class LoadVibeLimitationsSuccess implements Action {
  readonly type: string = LOAD_VIBE_LIMITATIONS_SUCCESS;
  constructor(public payload: any) {}
}

export class LoadVibeLimitationsFail implements Action {
  readonly type: string = LOAD_VIBE_LIMITATIONS_FAIL;
  constructor(public payload: any) {}
}

export type VibeLimitationsAction = LoadVibeLimitations |
  LoadVibeLimitationsSuccess |
  LoadVibeLimitationsFail;